<template>
  <div class="product-item-box" @click="handleProductItem">
    <div class="product-item-box__left">
      <div class="title-box">
        <div class="name-tag-box">
          <span id="product-name">{{ product && product.name }}</span>
          <ProductTag :tagList="product && product.labelList && Array.isArray(product.labelList) && product.labelList.filter(item => !!item)" />
        </div>
        <img id="bank-logo" :src="product && product.bankLogo" />
      </div>
      <div class="range-box">
        <RangeContentItem
          title="贷款额度"
          :value="product && product.quotaRangeEnd"
          unit="万以下"
        />
        <RangeContentItem title="贷款期限" :value="termRange(product)" unit="月" />
        <RangeContentItem :title="product.interestRateTypeName || '年息范围'" :value="annualInterestRange(product)" unit="%" />
        <RangeContentItem title="审批时间" :value="acceptanceTime(product)" unit="个工作日" tip="以银行实际审核时间为准" />
      </div>
      <slot name="additional"></slot>
    </div>
    <slot name="right"></slot>
  </div>
</template>

<script>
import ProductTag from './ProductTag'
import RangeContentItem from './RangeContentItem'
import { judgeAnnualInterestRange, judgeTermRange } from '@/utils/judge'
export default {
  props: {
    product: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    ProductTag,
    RangeContentItem
  },
  methods: {
    handleProductItem() {
      this.$emit('onProductItem', this.product.id)
    },
    // 年息范围
    annualInterestRange({ annualInterestRangeStart = '', annualInterestRangeEnd = '' } = {}) {
      return judgeAnnualInterestRange(annualInterestRangeStart, annualInterestRangeEnd)
    },
    // 受理时间
    acceptanceTime({ acceptanceTimeStart = '', acceptanceTimeEnd = '' } = {}) {
      return `${acceptanceTimeStart}~${acceptanceTimeEnd}`
    },
    // 贷款期限
    termRange({ termRangeStart = '', termRangeEnd }) {
      let content = judgeTermRange(termRangeStart, termRangeEnd)
      content = content.slice(0, -1)
      return content
    }
  }
}
</script>

<style lang="scss" scoped>
.product-item-box {
  margin: 0 auto 20px auto;
  padding: 20px 0;
  background: #fff;
  box-shadow: 0px 4px 16px 2px rgba(113, 128, 193, 0.15);
  border-radius: 8px;
  display: flex;
  transition: all 0.3s;
  cursor: pointer;
  box-sizing: border-box;

  &:hover {
    transform: scale(1.01);
    box-shadow: 0px 4px 16px 2px rgba(113, 128, 193, 0.4);
  }
  &__left {
    flex: 1;
    display: flex;
    padding: 0 30px;
    flex-direction: column;
    .title-box {
      @include displayCenter($justify-content: space-between);
      padding-bottom: 14px;
      border-bottom: 1px solid rgba(221, 221, 221, 1);
      .name-tag-box {
        display: flex;
        #product-name {
          @include text-30-400;
          color: #333;
          font-size: 20px;
        }
      }
      #bank-logo {
        height: 28px;
      }
    }
    .range-box {
      padding: 12px 30px 0;
      display: flex;
      justify-content: space-between;
    }
  }
}
.RangeContentItem-one {
  align-items: flex-start !important;
}
.RangeContentItem-three {
  align-items: flex-end !important;
}
</style>
